import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Add } from '../../service/BlogService';
import { GetAll } from '../../service/BlogCategoryService';

export default function BlogNew() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    console.log(file);
  };

  // blogCategory foreign key
  const [blogCategoryId, setBlogCategoryId] = useState('');
  const [blogCategorys, setBlogCategorys] = useState([]);
  const [keyword, setKeyword] = useState('');

  const FetchBlogCategory = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);
      if (response && Array.isArray(response.blogCategorys)) {
        // Filter only active categories
        const activeBlogCategorys = response.blogCategorys.filter(cat => cat.status === "active");
        setBlogCategorys(activeBlogCategorys);
      } else {
        setAppError(true);
        setAppErrorMessage('No BlogCategory Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchBlogCategory();
  }, []); // end of foreign key fetch



  const saveBlog = async (event) => {
    event.preventDefault();


    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

   //description required
    if (description.trim() === '') {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Description is required");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await Add(name, image, description, blogCategoryId);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Blog Successfully Added");
        setAppErrorMode("success");
        window.location.href = "/blog/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add blog. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add blog. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Blog Manage | {config.appName}</title>
      </Helmet>
      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Blog Add</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/blog/list"> Blog List </Link> / Blog Manage
            </span>
          </div>
          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <div className="form">
                  <form onSubmit={saveBlog} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Blog Category</label>
                          <select
                            className="form-control"
                            value={blogCategoryId} // Ensure this state is defined
                            onChange={(e) => setBlogCategoryId(e.target.value)} // Update correctly
                          >
                            <option value="">Select Blog Category</option>
                            {blogCategorys.map(blogCategoryOption => (
                              <option key={blogCategoryOption.id} value={blogCategoryOption.id}>
                                {blogCategoryOption.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            className='form-control'
                            type='text'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Image</label>
                          <input
                            className='form-control'
                            type='file'
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                      <div className='col-lg-12 col-md-12 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Description</label>
                          <textarea
                            className='form-control'
                            rows={8}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Add Blog
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
